import { Image, theme } from 'antd';
import { FileImageOutlined } from '@ant-design/icons';

interface CoverThumbProps {
  url?: string | null;
  size: number;
}

/** Square 1:1 cover thumbnail with a placeholder when missing. */
export const CoverThumb = ({ url, size }: CoverThumbProps) => {
  const { token } = theme.useToken();

  return url ? (
    <Image
      src={url}
      width={size}
      height={size}
      style={{
        objectFit: 'cover',
        borderRadius: token.borderRadiusLG,
        border: `${token.lineWidth}px solid ${token.colorBorderSecondary}`,
      }}
    />
  ) : (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: token.borderRadiusLG,
        border: `${token.lineWidth}px dashed ${token.colorBorder}`,
        background: token.colorFillQuaternary,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <FileImageOutlined
        style={{ fontSize: size / 4, color: token.colorTextQuaternary }}
      />
    </div>
  );
};
